<template>
  <div>
    <!--  APP版本控制-->
    <baseBreadcrumb :page="$t('message.APPVersionControl')" :menu="$t('message.operationAndMaintenance')" />
    <div class="body">
      <div class="add">
        <!-- 新建 -->
        <el-button type="primary" size="small" @click="add" v-if="isAuth(435)">{{ $t('message.newBuild') }} </el-button>
      </div>
      <el-tabs v-model="datas.version_type" type="card" @tab-click="switchOver">
        <!--  安卓 -->
        <el-tab-pane :label="$t('message.Android')" name="3"></el-tab-pane>
        <!--  安卓 -->
        <el-tab-pane :label="$t('message.IOS')" name="4"></el-tab-pane>
      </el-tabs>
      <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
        :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">

        <!-- 版本号 -->
        <el-table-column align="center" :label="$t('message.versionNumber')" prop="version_code" width="200">
        </el-table-column>
        <!-- 是否强更 -->
        <el-table-column align="center" :label="$t('message.whetherItIsStronger')" prop="name" width="120">
          <template slot-scope="scope">
            {{ scope.row.is_compel == 1 ? $t('message.are') : $t('message.no') }}
          </template>
        </el-table-column>
        <!-- 弹窗文案（中文） -->
        <el-table-column align="center" :label="$t('message.popUpCopy_Chinese')" prop="message_chinese">
        </el-table-column>
        <!-- 弹窗文案（日文） -->
        <el-table-column align="center" :label="$t('message.popUpCopy_Japanese')" prop="message_translate">
        </el-table-column>
        <!-- 发布时间 -->
        <el-table-column align="center" :label="$t('message.timeOfRelease')" prop="created_at" width="150">
        </el-table-column>
        <!-- 正式包名 -->
        <el-table-column align="center" :label="$t('message.officialPackageName')" prop="version_name" width="200">
        </el-table-column>
        <!-- 操作 -->
        <el-table-column align="center" :label="$t('message.operation')" width="200">
          <template slot-scope="scope">
            <!-- 编辑 -->
            <el-button type="primary" size="mini" @click="edit(scope.row)" v-if="isAuth(435)">{{ $t('message.redact')
            }}</el-button>
            <!-- 删除 -->
            <el-button type="danger" size="mini" @click="delItem(scope.row.id)" v-if="isAuth(436)">{{ $t('message.delete')
            }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 新增编辑 -->
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="dialogVisible" width="580px" center>
      <div class="content">
        <el-form :model="itemData" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
          <!-- 版本号 -->
          <el-form-item :label="$t('message.versionNumber')" prop="version_code">
            <el-input v-model="itemData.version_code"></el-input>
          </el-form-item>
          <!-- 是否强更 -->
          <el-form-item :label="$t('message.whetherItIsStronger')" prop="is_compel">
            <el-radio v-model="itemData.is_compel" :label="1">{{ $t('message.are') }}</el-radio>
            <el-radio v-model="itemData.is_compel" :label="0">{{ $t('message.no') }}</el-radio>
          </el-form-item>
          <!-- 弹窗文案（中文） -->
          <el-form-item :label="$t('message.popUpCopy_Chinese')" prop="message_chinese">
            <el-input v-model="itemData.message_chinese" type="textarea" resize="none"></el-input>
          </el-form-item>
          <!-- 弹窗文案（日文） -->
          <el-form-item :label="$t('message.popUpCopy_Japanese')" prop="message_translate">
            <el-input v-model="itemData.message_translate" type="textarea" resize="none"></el-input>
          </el-form-item>
          <!-- 正式包名 -->
          <el-form-item :label="$t('message.officialPackageName')" prop="version_name">
            <el-input v-model="itemData.version_name"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabsList: [],
      tableData: [],
      datas: {
        version_type: '3'
      },
      total: 0,
      //新增编辑用
      title: '',
      dialogVisible: false,
      itemData: {},
      rules: {
        version_type: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        version_code: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        version_name: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        message_chinese: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
        message_translate: [{
          required: true,
          message: this.$t("message.TheRequired"),
          trigger: "blur",
        },],
      },
    };
  },
  created() {

    this.appVersionList()
  },
  methods: {
    appVersionList() {
      this.$api.siteConfiguration.appVersionList(this.datas).then(res => {
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    //切换
    switchOver() {
      this.datas.page = 1;
      this.appVersionList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.appVersionList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.appVersionList();
    },
    //删除
    delItem(id) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.siteConfiguration.appVersionDelete({ id }).then(res => {
            this.$message.success(res.msg);

            this.appVersionList();
          });
        })
        .catch(() => { });

    },
    //新增
    add() {
      this.title = this.$t('message.add')
      this.itemData = {
        version_type: this.datas.version_type,
        version_name: '',
        version_code: '',
        is_compel: 1,
        message_chinese: '',
        message_translate: '',
      }
      this.dialogVisible = true
    },
    //编辑
    edit(item) {
      this.title = this.$t('message.compile')
      this.itemData = JSON.parse(JSON.stringify(item))
      this.dialogVisible = true
    },
    //保存
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api.siteConfiguration.appVersionSave(this.itemData).then(res => {
            this.$message.success(res.msg)
            this.appVersionList()
            this.dialogVisible = false
          })
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.add {
  position: relative;

  .el-button {
    position: absolute;
    top: 00px;
    right: 10px;
    z-index: 99;
  }
}

.content {
  padding: 0 20px;

  .el-select {
    width: 100%;
  }
}
</style>